/**
 * Pre-compiled de messages for Toast
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { dismiss: `Schließen` };
